import { TextProps } from '@mantine/core';
import { normalizeTextContent } from '@bariendo/lib/services';

// Types
export interface BaseHighlightableTextProps extends TextProps {
  text: string;
  searchTerm: string;
  highlightStyle?: React.CSSProperties;
  maxLength?: number;
}

export interface HighlightableTextProps extends BaseHighlightableTextProps {
  richTextContent?: object;
}

export interface Match {
  start: number;
  end: number;
}

// Constants
export const DEFAULT_HIGHLIGHT_STYLE: React.CSSProperties = {
  backgroundColor: '#ffeb3b',
  padding: '0 2px',
  borderRadius: '3px',
};

// Shared utilities
export const findMatches = (text: string, term: string): Match[] => {
  if (!term.trim()) return [];

  const normalizedText = normalizeTextContent(text);
  const normalizedTerm = normalizeTextContent(term);
  const matches: Match[] = [];

  let index = 0;
  while ((index = normalizedText.indexOf(normalizedTerm, index)) !== -1) {
    matches.push({ start: index, end: index + normalizedTerm.length });
    index += normalizedTerm.length;
  }

  return matches;
};
